import React, { useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import Row from '@/components/Row';
import Modal from '@/components/Modal';

import styled from 'styled-components';
import { TYPE } from '@/theme';
import { ChainId, DefaultChainId } from '../../constants';

import NuvoSVG from '@/assets/images/nuvo.svg';
import TrustWalletSVG from '@/assets/images/trust-wallet.svg';
import Loading from '@/components/Loading';
import { useChainId, useConnect } from 'wagmi';
import { useConnectModal } from '@rainbow-me/rainbowkit';

const Content = styled.div`
    width: 460px;
    box-sizing: border-box;
    /* padding: 10px 30px; */

    .nextButton {
        width: 80%;
    }

    .walletsList {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 18px;
        /* margin-top: 30px; */

        .item {
            width: 400px;
            height: 66px;
            margin-top: 12px;
            background-color: ${({ theme }) => theme.c.bg04};
            border-radius: 10px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: ${({ theme }) => theme.c.t01};
            box-sizing: border-box;
            padding: 0 10px;

            .icon {
                width: 32px;
                height: 32px;
                margin-left: 10px;
                background-size: 100%;
            }

            &.polis {
                .icon {
                    background-image: url(${NuvoSVG});
                }
            }
            &.installMetaMask {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row;

                .metaMask {
                    width: 32px;
                    height: 32px;
                    background-image: url(${require('@/assets/images/metamask-icon.png')});
                    background-size: 100% 100%;
                    background-position: center center;
                    margin: 8px 0;
                }
            }

            &.trustWallet {
                .icon {
                    width: 32px;
                    height: 38px;
                    background: url(${TrustWalletSVG}) no-repeat;
                    background-size: 100%;
                    background-position: center center;
                }
            }

            &.rainbow {
                .icon {
                    width: 32px;
                    height: 32px;
                    border-radius: 4px;
                    background: url('https://www.rainbowkit.com/rainbow.svg')
                        no-repeat;
                    background-size: 100%;
                    background-position: center center;
                }
            }
            &.metamask {
                .icon {
                    width: 32px;
                    height: 32px;
                    background: url(${require('@/assets/images/metamask-icon.png')})
                        no-repeat;
                    background-size: 100%;
                    background-position: center center;
                }
            }
            // &.walletConnect {
            //     background: url(../../assets/images/walletconnect.png) no-repeat;
            //     background-size: 208px 34px;
            //     background-position: center center;
            // }
        }
    }

    .warning {
        line-height: 1.7;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
      width: 100%;
        .walletsList {
            .item {
                width: 100%;
            }
        }
    `}
`;

interface Props {
    isOpen: boolean;
    onClose(): void;
}

export default function ConnectWallet({ isOpen, onClose }: Props) {
    const { openConnectModal } = useConnectModal();
    const [isOpenWeb3Modal, setIsOpenWeb3Modal] = useState(false);

    const chainId = useChainId() as ChainId;
    const { connect, connectors } = useConnect();

    // useEffect(() => {
    //     setTheme({
    //         themeMode: isDark ? 'dark' : 'light',
    //     });
    // }, [isDark]);

    const metaMaskNotInstall = useMemo(() => {
        return !connectors.find((item) => item.name === 'MetaMask');
    }, [connectors]);

    const trustWalletNotInstall = useMemo(() => {
        return !connectors.find((item) => item.name === 'Trust Wallet');
    }, [connectors]);

    async function handleClick(name: string) {
        if (name === 'metamask') {
            const mmConnector = connectors.find(
                (item) => item.name === 'MetaMask',
            );
            if (mmConnector) {
                connect({
                    connector: mmConnector,
                    chainId: DefaultChainId,
                });
            } else {
                open();
            }
            onClose();
        } else if (name === 'trustWallet') {
            const mmConnector = connectors.find(
                (item) => item.name === 'Trust Wallet',
            );
            if (mmConnector) {
                connect({
                    connector: mmConnector,
                    chainId: DefaultChainId,
                });
            } else {
                open();
            }
            onClose();
        } else if (openConnectModal) {
            setIsOpenWeb3Modal(true);
            openConnectModal();
            setIsOpenWeb3Modal(false);
            onClose();
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            // customContentClass={style.modalContent}
        >
            <Content>
                <Row justify="center">
                    <TYPE.main fontSize={16} fontWeight="bold">
                        Connect your wallet
                    </TYPE.main>
                </Row>
                <div className={'walletsList'}>
                    <div
                        className={cx('item', 'metamask')}
                        onClick={() => {
                            if (metaMaskNotInstall) {
                                window.open('https://metamask.io/');
                            } else {
                                handleClick('metamask');
                            }
                        }}
                    >
                        <TYPE.main fontSize={14}>
                            {metaMaskNotInstall
                                ? 'Install Metamask'
                                : 'Connect by Metamask'}
                        </TYPE.main>
                        <div className="icon" />
                    </div>
                    <div
                        className={cx('item', 'trustWallet')}
                        onClick={() => {
                            if (trustWalletNotInstall) {
                                window.open('https://trustwallet.com/');
                            } else {
                                handleClick('trustWallet');
                            }
                        }}
                    >
                        <TYPE.main fontSize={14}>
                            {trustWalletNotInstall
                                ? 'Install Trust Wallet'
                                : 'Connect by Trust Wallet'}
                        </TYPE.main>
                        <div className="icon" />
                    </div>
                    <div
                        className={cx('item', 'rainbow')}
                        onClick={() => {
                            handleClick('rainbow');
                        }}
                    >
                        {isOpenWeb3Modal ? (
                            <>
                                <TYPE.main fontSize={14}>Loading</TYPE.main>
                                <Loading style={{ color: '#000' }} size={20} />
                            </>
                        ) : (
                            <>
                                <TYPE.main fontSize={14}>
                                    Connect by Rainbow Wallet
                                </TYPE.main>
                                <div className="icon" />
                            </>
                        )}
                    </div>
                </div>
            </Content>
        </Modal>
    );
}
